var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-col",
    {
      staticClass: "flex justify-center",
      staticStyle: { "max-width": "450px" },
      attrs: { cols: "12" },
    },
    [
      _c(
        "v-card",
        {
          staticClass: "soli-round w-full",
          class: {
            "mx-3": _vm.$vuetify.breakpoint.smAndUp,
            "mx-auto": _vm.$vuetify.breakpoint.xs,
          },
          attrs: { light: "", elevation: "6" },
        },
        [
          _c(
            "v-container",
            [
              !_vm.showCreateRelationship
                ? _c(
                    "div",
                    { staticClass: "contents" },
                    [
                      _c("v-card-subtitle", [
                        _vm._v(
                          "Get recommendations for another student and register\n                    them for classes. Or continue to checkout.\n                "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-card-actions",
                        { staticClass: "flex flex-col gap-2 px-4" },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                outlined: "",
                                rounded: "",
                                large: "",
                                block: "",
                                color: "accent",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.showCreateRelationship = true
                                },
                              },
                            },
                            [
                              _vm._v("Register another student"),
                              _c("v-icon", { attrs: { right: "" } }, [
                                _vm._v("person_add"),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                outlined: "",
                                rounded: "",
                                large: "",
                                block: "",
                                color: "dark",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.$inertia.visit(_vm.route("checkout.show"))
                                },
                              },
                            },
                            [
                              _vm._v("Continue to checkout"),
                              _c("v-icon", { attrs: { right: "" } }, [
                                _vm._v("shopping_cart"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showCreateRelationship
                ? _c(
                    "v-form",
                    {
                      ref: "form",
                      staticClass:
                        "flex justify-center pa-4 pb-0 align-center gap-4",
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.submit.apply(null, arguments)
                        },
                      },
                      model: {
                        value: _vm.valid,
                        callback: function ($$v) {
                          _vm.valid = $$v
                        },
                        expression: "valid",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "flex flex-col gap-4" },
                        [
                          _c("div", { staticClass: "soli-grey px-1" }, [
                            _vm._v("Student Information:"),
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-row",
                            {
                              staticClass: "w-full",
                              class: { "gap-4": _vm.$vuetify.breakpoint.xs },
                              attrs: { "no-gutters": "" },
                            },
                            [
                              _c(
                                "v-col",
                                {
                                  class: {
                                    "pr-2": _vm.$vuetify.breakpoint.smAndUp,
                                  },
                                  attrs: { cols: "12", sm: "6" },
                                },
                                [
                                  _c("SoliText", {
                                    attrs: {
                                      icon: "person",
                                      label: "First Name",
                                      rules: _vm.rules_required,
                                      hideDetails: "auto",
                                      error: _vm.errors?.first_name,
                                    },
                                    model: {
                                      value: _vm.form.first_name,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "first_name", $$v)
                                      },
                                      expression: "form.first_name",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                {
                                  class: {
                                    "pl-2": _vm.$vuetify.breakpoint.smAndUp,
                                  },
                                  attrs: { cols: "12", sm: "6" },
                                },
                                [
                                  _c("SoliText", {
                                    attrs: {
                                      icon: "people",
                                      label: "Last Name",
                                      rules: _vm.rules_required,
                                      hideDetails: "auto",
                                      error: _vm.errors?.last_name,
                                    },
                                    model: {
                                      value: _vm.form.last_name,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "last_name", $$v)
                                      },
                                      expression: "form.last_name",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("SoliBirthday", {
                            attrs: {
                              label: "Birthday",
                              required: "",
                              "hide-details": "auto",
                            },
                            model: {
                              value: _vm.form.birthday,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "birthday", $$v)
                              },
                              expression: "form.birthday",
                            },
                          }),
                          _vm._v(" "),
                          _c("v-select", {
                            attrs: {
                              items: _vm.relationshipOptions,
                              "item-text": "relation",
                              label: "Relationship",
                              "return-object": "",
                              outlined: "",
                              dense: "",
                              rules: _vm.rules_select,
                              "prepend-inner-icon": "handshake",
                              "hide-details": "auto",
                            },
                            model: {
                              value: _vm.form.relation,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "relation", $$v)
                              },
                              expression: "form.relation",
                            },
                          }),
                          _vm._v(" "),
                          _c("SoliInstruments", {
                            attrs: {
                              multiple: false,
                              "return-object": false,
                              rules: _vm.rules_select,
                              error: _vm.errors.instrument_id,
                              "hide-details": "auto",
                              notSure: "",
                              autocomplete: "",
                            },
                            model: {
                              value: _vm.form.instrument_id,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "instrument_id", $$v)
                              },
                              expression: "form.instrument_id",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "flex flex-col gap-2" },
                            [
                              _c("SoliBtn", {
                                staticClass: "mt-3",
                                attrs: {
                                  text: "See Membership Options",
                                  large: "",
                                  block: "",
                                  gradient: "gradient-orange",
                                  loading: _vm.loading,
                                  type: "submit",
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    color: "dark",
                                    text: "",
                                    block: "",
                                    rounded: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.$inertia.visit(
                                        _vm.route("checkout.show")
                                      )
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                            Nevermind, Checkout Now"
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }